var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ServicesCard',{on:{"click":_vm.click},model:{value:(_vm.buttons),callback:function ($$v) {_vm.buttons=$$v},expression:"buttons"}}),_c('RHorRODialog',{attrs:{"query":_vm.query},model:{value:(_vm.showRHorRODialog),callback:function ($$v) {_vm.showRHorRODialog=$$v},expression:"showRHorRODialog"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }